
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { HierarchicalTheme } from '@/repositories/data/Theme';

@Component({ name: 'SearchThemeSelectorElement' })
export default class SearchThemeSelectorElement extends Vue {
    public expanded: boolean = false;

    @Prop({ type: Object, required: true }) public readonly theme!: HierarchicalTheme;
    @Prop({ type: String, default: '' }) public readonly filter!: string;
    @Prop({ type: String, default: null }) public readonly selectedThemeId!: string | null;
    @Prop({ type: String, required: true }) public readonly fieldName!: string;

    public get hasActiveFilter(): boolean {
        return this.filter.trim().length > 0;
    }

    public get normalizedFilter(): string {
        return this.filter.trim().toLowerCase();
    }

    public get matchesFilter(): boolean {
        return this.matchesThemeFilter(this.theme);
    }

    public get isSelected(): boolean {
        return this.selectedThemeId !== null && this.selectedThemeId === this.theme.id;
    }

    public get isChild(): boolean {
        return this.theme.parent !== null;
    }

    public get childThemes(): HierarchicalTheme[] {
        return this.theme.children;
    }

    public get hasChildren(): boolean {
        return this.childThemes.length > 0;
    }

    public get visibleChildThemes(): HierarchicalTheme[] {
        return !this.hasActiveFilter || this.matchesFilter
            ? this.childThemes
            : this.childThemes.filter(c => this.matchesThemeFilter(c));
    }

    public get isVisible(): boolean {
        return !this.hasActiveFilter || this.matchesFilter || this.visibleChildThemes.length > 0;
    }

    @Watch('filter')
    public onFilterChanged() {
        // While filtering, every matching theme is expanded by default and can be collapsed individually.
        this.expanded = this.hasActiveFilter;
    }

    public onToggle() {
        if (this.hasChildren) {
            this.expanded = !this.expanded;
            return;
        }
        this.$emit('select', this.theme.id);
    }

    public matchesThemeFilter(theme: HierarchicalTheme): boolean {
        if (this.normalizedFilter.length === 0 || theme.searchTerms.length === 0) {
            return false;
        }

        return theme.searchTerms.some((_, index) =>
            theme.searchTerms
                .slice(index)
                .join(' ')
                .startsWith(this.normalizedFilter),
        );
    }
}
